import React from "react"
import { useEffect } from 'react';
import Navbar from "./Navbar"
import Menu from "./Menu"
import Footer from "./Footer"
import { FloatButton } from 'antd'
import category from '@/assets/js/category'
import { loadLiveChat } from '@/utils/liveChat';
import { loadGtm } from '@/utils/gtm';
import { loadMatomo } from "@/utils/matomo";

interface LayoutProps {
  children: React.ReactNode;
  wideScreen?: boolean;  // 是否使用宽屏
  useChristmasTheme?: boolean; // 是否使用圣诞主题
  notStickyNavbar?: boolean; // 是否取消Navbar吸顶效果
}

export default function DefaultLayout(props: LayoutProps) {
  useEffect(() => {
    function handleWindowLoad() {
      loadMatomo()
      loadLiveChat();
      loadGtm();
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  return (
    <div>
      <Navbar
        wideScreen={props.wideScreen}
        categoryData={category}
        useChristmasTheme={props.useChristmasTheme}
        sticky={props.notStickyNavbar ? false : true}
      />

      <Menu 
        wideScreen={props.wideScreen}
        categoryData={category}
        useChristmasTheme={props.useChristmasTheme} 
      />

      <main style={{ background: '#F5F5F5' }}>{props.children}</main>

      <Footer />
      <FloatButton.BackTop />
    </div>
  )
}